import React from 'react';
import PresentationViewer from './ppt-view';
import VideoPlayer from './video';

const AttendeeSliderView = () => {
  const videoJsOptions = {
    autoplay: true,
    controls: true,
    sources: [{
      src: 'http://vjs.zencdn.net/v/oceans.mp4',
      type: 'video/mp4'
    }]
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', height: 'calc(100vh - 60px)' }}>
        <div style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <VideoPlayer {...videoJsOptions} />
        </div>
        <div style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', overflow: 'hidden' }}>
          <PresentationViewer />
        </div>

      </div>
    </div>
  );
};

export default AttendeeSliderView;
